module.exports = __webpack_public_path__ + "static/media/gitlab.f19f5de4.svg";